























import Vue from 'vue';
import InlineSVG from 'vue-inline-svg';
import TIcons from '../../../types/TIcons';
import { IFooterIconsComponent } from '../../../common/interfaces/footer.interface';
import SocialMediaIcons from './SocialMediaIcons.vue';

export default Vue.extend({
  name: `DesktopLogos`,
  components: { InlineSVG, SocialMediaIcons },
  data(): IFooterIconsComponent {
    return {
      icons: TIcons,
    };
  },
});
